// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Legend,
//   LabelList,
//   Rectangle,
// } from "recharts";

// const percentFormatter = (value: number) => `${value}%`;

// type ChartData = {
//   name: string;
//   accepted: number;
//   rejected: number;
// };

// interface ConversionChartsComponentProps {
//   title: string;
//   data: ChartData[];
//   colordata: string[]; // Array of color hex codes (with #)
// }

// // Custom tick to wrap long text into multiple lines
// const WrappedTick = ({ x, y, payload }: any) => {
//   const words = payload.value.split(" ");
//   return (
//     <g transform={`translate(${x},${y + 10})`}>
//       {words.map((word: string, index: number) => (
//         <text
//           key={index}
//           x={0}
//           y={index * 12}
//           textAnchor="middle"
//           fill="#666"
//           fontSize={10}
//         >
//           {word}
//         </text>
//       ))}
//     </g>
//   );
// };


// export default function ConversionCharts({
//   title,
//   data,
//   colordata,
// }: ConversionChartsComponentProps): JSX.Element {
//   return (
//     <div>
//       {/* Chart Title */}
//       <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

//       {/* Chart with Scroll */}
//       <div className="bg-white pt-8 px-4 pb-4 rounded-xl shadow w-full overflow-x-auto">
//         <div style={{ width: Math.max(data.length * 120, 600), height: 300 }}>
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart
//               data={data}
//               margin={{ top: 0, right: 20, left: 12, bottom: 0 }}
//             >
//               <XAxis
//                 dataKey="name"
//                 tick={<WrappedTick />}
//                 tickLine={false}
//                 axisLine={false}
//                 interval={0}
//               />
//               <YAxis tickFormatter={percentFormatter} domain={[0, 100]} />

//               <Legend verticalAlign="top" height={24} />

//               <Bar
//                 dataKey="accepted"
//                 stackId="a"
//                 name="Accepted Offers"
//                 barSize={40}
//                 fill={colordata[0]}
//                 // radius={[5, 5, 0, 0]}
//               >
//                 <LabelList
//                   dataKey="accepted"
//                   position="insideBottom"
//                   formatter={(v: number) => (v > 0 ? `${v.toFixed()}%` : "")}
//                   fill="#fff"
//                 />
//               </Bar>

//               <Bar
//                 dataKey="rejected"
//                 stackId="a"
//                 name="Rejected Offers"
//                 barSize={40}
//                 fill={colordata[1]}
//                 // radius={[5, 5, 0, 0]}
//               >
//                 <LabelList
//                   dataKey="rejected"
//                   position="insideTop"
//                   formatter={(v: number) => (v > 0 ? `${v.toFixed()}%` : "")}
//                   fill="#fff"
//                 />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// }


import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  LabelList,
  CartesianGrid,
} from "recharts";

const percentFormatter = (value: number) => `${value}%`;

type ChartData = {
  name: string;
  accepted: number;
  rejected: number;
};

interface ConversionChartsComponentProps {
  title: string;
  data: ChartData[];
  colordata: string[];
}

export default function ConversionCharts({
  title,
  data,
  colordata,
}: ConversionChartsComponentProps): JSX.Element {
  return (
    <div>
      <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

      <div className="bg-white pt-6 px-4 pb-4 rounded-xl shadow w-full overflow-x-auto">
        <div
          style={{
            width: "100%",
            height: Math.max(data.length * 45, 250),
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 10, right: 40, left: 20, bottom: 10 }}
              barCategoryGap={18}
            >
              <CartesianGrid
                strokeDasharray="0"
                horizontal={false}
                vertical={true}
                stroke="#E5E7EB"
              />
              <XAxis
                type="number"
                domain={[0, 100]}
                ticks={[0, 25, 50, 75, 100]}
                tickFormatter={percentFormatter}
                axisLine={false}
                tickLine={false}
              />

              <YAxis
                type="category"
                dataKey="name"
                width={80}
                axisLine={false}
                tickLine={false}
                
              />

              <Legend
                verticalAlign="top"
                align="right"
                iconType="circle"
                wrapperStyle={{ paddingBottom: 16 }}
              />

              <Bar
                dataKey="accepted"
                stackId="a"
                name="Accepted Offers"
                fill={colordata[0]}
                radius={[8, 0, 0, 8]}
                barSize={18}
              >
                <LabelList
                  dataKey="accepted"
                  position="center"
                  formatter={(value: number) =>
                    value > 8 ? `${Math.round(value)}%` : ""
                  }
                  fill="#fff"
                />
              </Bar>

              <Bar
                dataKey="rejected"
                stackId="a"
                name="Rejected Offers"
                fill={colordata[1]}
                radius={[0, 8, 8, 0]}
                barSize={18}
              >
                <LabelList
                  dataKey="rejected"
                  position="center"
                  formatter={(value: number) =>
                    value > 8 ? `${Math.round(value)}%` : ""
                  }
                  fill="#fff"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}